import React, { useEffect, useState } from "react";
import { Button, Drawer, Form, Input, Space } from "antd";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { BASE_CRM_URL } from "../../../components/config/config";

const AddTodoDrawer = ({ open, onClose, onTodoAdded }) => {
  const [form] = Form.useForm();

  const [isSaving, setIsSaving] = useState(false);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");

  const staffId = userDetails?.staffid;

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleSubmit = async (values) => {
    try {
      setIsSaving(true);

      const payload = {
        description: values.description.trim(),
        staffid: Number(staffId),
        item_order: 1,
      };

      const response = await fetch(`${BASE_CRM_URL}todo/AddTodo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to add todo");
      }

      const data = await response.json();

      if (data?.Status) {
        await Swal.fire({
          icon: "success",
          title: "Todo Added",
          text: data?.Message || "Todo added successfully",
          timer: 1500,
          showConfirmButton: false,
        });

        form.resetFields();

        // Close drawer
        onClose();

        // Refresh todo list
        if (onTodoAdded) {
          onTodoAdded();
        }
      } else {
        throw new Error(data?.Message || "Unable to add todo");
      }
    } catch (error) {
      console.error("Add Todo Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.message || "Unable to add todo",
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Drawer
      title="Add Todo"
      placement="right"
      width={450}
      open={open}
      onClose={onClose}
      destroyOnClose
      footer={
        <div className="d-flex justify-content-end">
          <Space>
            <Button onClick={onClose} disabled={isSaving}>
              Cancel
            </Button>

            <Button
              type="primary"
              loading={isSaving}
              onClick={() => form.submit()}
            >
              Add Todo
            </Button>
          </Space>
        </div>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Todo"
          name="description"
          rules={[
            {
              required: true,
              message: "Please enter todo",
            },
            {
              whitespace: true,
              message: "Todo cannot be empty",
            },
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Enter todo"
            maxLength={500}
            showCount
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

AddTodoDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onTodoAdded: PropTypes.func.isRequired,
};

export default AddTodoDrawer;
